/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderApiModel } from './providerApiModel';


export interface PageDataApiModelOfProviderApiModel { 
    currentPage: number;
    perPage: number;
    totalCount: number;
    totalPages: number;
    items: Array<ProviderApiModel>;
}

